import Vue from 'vue';
import Router from 'vue-router';
import globalRoutes from '@/router/global/globalRoutes';
import userRoutes from '@/router/user/userRoutes';
import {isUserLoggedIn} from '@/store/isUserLoggedIn';

Vue.use(Router);

var allRoutes = []
allRoutes = allRoutes.concat(globalRoutes, userRoutes);

const routes = allRoutes

const router = new Router({
	mode: 'history',
	// TODO: Check if web server is configured to handle accessing routes
	// other than / (index) route
	base: process.env.BASE_URL || '/',
	routes: routes
});

router.beforeEach((to, from, next)=>{
	if(to.matched.some(record => record.meta.requiresAuth)) {
		if(!isUserLoggedIn()) {
			next({name: 'index'})
		} else {
			next()
		}
	} else {
		next()
	}
})

export default router;